enum KangarooStatus {
    /** 未购买 */
    NOT_PURCHASED = 0,
    /** 已购买、生效中 */
    UNEXPIRE = 10,
    /** 已购买、已失效 */
    EXPIRE = 20,
}

interface IKangarooInfo {
    /** 袋鼠店长版本名称 */
    name: string | null;
    /** 袋鼠店长状态 */
    status: KangarooStatus;
    /** logo地址 */
    url: string;
    /** 袋鼠店长版本 v1 v2... */
    version: string | null;
}

interface IAllPoiList {
    /** 店铺状态描述文案 */
    businessDesc: string;
    category: string;
    /** 城市id */
    cityLocationId: number;
    firstTagId: number;
    /** 是否为团餐商家  0否  1是 */
    groupMealPoi: number;
    /** 门店id */
    id: number;
    /** 是否是第三方配送商家，0-否，1-是 */
    is3rdShipping: number;
    /** 袋鼠店长信息 */
    kangarooPackageInfo: IKangarooInfo;
    /** 门店名称 */
    poiName: string;
    /** 是否采用自助服务 0否  1是 */
    self_service: number;
    status: number;
}

enum BusinessStatus {
    /** 非置休 */
    OPEN = 1,
    /** 门店置休 */
    REST = 3,
}

enum BusinessSubStatus {
    /** 营业中 */
    OPEN = 0,
    /** 仅接受预定 */
    RESERVE = 2,
    /** 待开始营业 */
    WILLOPEN = 4,
}

interface IBusinessStatus {
    /** 接口状态 */
    code: number;
    /** 是否有临时营业时段 */
    hasSpecialShippingTime: boolean;
    /** 置休类型 非强制置休：undefined 0 2  强制置休：1 3 */
    restType: number | undefined;
    /** 营业时间（区间 ） 08:30-21:00*/
    shippingTimeDesc: string;
    /** 营业状态(是否置休) */
    status: BusinessStatus;
    /** 营业状态文案 */
    statusDescInfo: string;
    /** 营业状态 */
    subStatus: BusinessSubStatus;
    /** 营业状态tag文案 */
    wmPoiStatusDesc: string;
    /** 重要通知文案 */
    importantNotice?: string;
    /** 临时营业时间 */
    specialShippingTime?: string;
    /**  */
    noticeUrl?: string;
    /** 置休原因 */
    restDesc?: string;
    /** 置休时间段 */
    restTime?: string;
    /** 置休恢复时间 */
    statusRestoreMaxTime?: string;
    /** 门店上单状态    0、下线；1、上线；2、上单中；3、审核通过可上线 */
    valid: number;
    /** 0:默认值/灰度外 1:歇业保护开启，且正在生效 */
    operationStatus?: number;
    /** 置休code，当restCode=1896时进行特殊逻辑处理；注意：restCode有可能不存在，或者未null */
    restCode?: number | undefined;
}

interface IgoodsCheckDesc {
    lineOne: string;
    lineTwo: string;
}
interface IChangeBusinessStatus {
    /** 门店商品校验 */
    goodsCheckCode: number;
    /** 门店商品校验文案 */
    goodsCheckDesc: IgoodsCheckDesc;
    restore_time: 0;
    /** 营业时间 xx:xx-xx:xx*/
    shippingTimeDesc: string;
    /** 置休状态 */
    status: BusinessStatus;
    /** 营业状态tag文案 */
    strWmPoiStatusDesc: string;
    /** 营业状态 */
    subStatus: BusinessSubStatus;
}

enum UnreadMessageType {
    /** 全部消息 */
    ALL = -2,
    /** 平台公告 */
    PLATFORM = 5,
    /** 功能通知 */
    FUNCTION = 6,
    /** 活动推荐 */
    RECOMMEND = 7,
    /** 其他消息 */
    OTHERS = 8,
    /** 营销活动 */
    MARKETING = 10,
    /** 运营攻略 */
    STRATEGY = 11,
    /** 重要消息 */
    IMPORTANT = 12,
}
interface IUnreadMessageCount {
    /** 消息名称 */
    categoryName: string;
    /** 消息权重 */
    categorySort: number;
    /** 消息类型 */
    categoryType: UnreadMessageType;
    /** 消息数量 */
    categoryUnreadCount: 99;
}

interface IQuerySubMenuItem {
    interfaceCode: string | null;
    limitInfo: string | null;
    /** 侧边tag */
    mask: string;
    /** 菜单code */
    menuCode: string;
    /** 菜单icon */
    menuIcon: string | null;
    rank: string;
    /** 子菜单 */
    subMenuName: string;
    /** 跳转链接 */
    url: string;
}

interface IQueryMenuItem {
    interfaceCode: string | null;
    limitInfo: string | null;
    /** 侧边tag */
    mask: string;
    /** 菜单code */
    menuCode: string;
    /** 菜单icon */
    menuIcon: string | null;
    /** 菜单名 */
    menuName: string;
    rank: string;
    /** 子菜单 */
    subMenus: IQuerySubMenuItem[];
    /** 跳转链接 */
    url: string;
}

interface IQueryMenu {
    is_in_aggregation_gray: boolean;
    menus: IQueryMenuItem[];
}

interface IMenuInfoItem {
    /** 菜单名 */
    name: string;
    /** 是否是外部链接（proxy） */
    prefix: string;
    /** 菜单链接 */
    url: string;
    /** 自定义正则匹配 - 暂未使用 */
    regExp?: RegExp;
}
interface IMenuInfo {
    [key: string]: IMenuInfoItem[];
}

type IBusinessStatusHandlerItem = {
    text: string;
    btn: {
        text: string;
        status?: number;
        /** 按钮是否置灰 */
        disabled?: boolean;
        /** 跳转链接 */
        jumpUrl?: string;
    };
};

interface IgrayNewPageConfig {
    /** 新页面地址 */
    newPath: string;
    /** 灰度百分比 */
    percent: number;
    /** 当前页面地址 */
    proxyPath: string;
}

/** 万分比，支持白名单 */
interface IgrayNewPageConfigAdvanced {
    /** 新页面地址 */
    newPath: string;
    /** 灰度万分比 */
    percent: number;
    /** 当前页面地址 */
    proxyPath: string;
    /** 账号白名单列表 */
    openList?: string[];
    advanced: true;
}

interface IcustomerServiceInfo {
    script: {
        show: number;
        value: string;
    };
    scsUrl: string;
    showNewSCS: number;
    showOldSCS: number;
    /** 是否打开服务大厅 */
    isWmHall: boolean;
    text: {
        show: number;
        value: string;
    };
}

interface MatchedMenuType {
    /** 高亮的一级菜单 */
    menuCode: string;
    /** 高亮的一级菜单名字 */
    menuName: string;
    /** 高亮的二级菜单 */
    subMenuCode: string;
    /** 高亮的二级菜单名字 */
    subMenuName: string;
}

/** 非SLA商家7折赔付留痕 */
interface CompensateProtocalType {
    /** 是否签署回调 */
    signStatus: boolean;
    /** 是否需要展示弹框 */
    displayStatus: boolean;
}

enum CustomizedShowArrType {
    /** head-搜索框 */
    SEARCH_BOX = 'searchBox',
    /** head-打印入口 */
    PRINT_ICON = 'printIcon',
    /** head-门店状态 */
    BUSINESS_STATE = 'businessState',
    /** head-门店列表下拉框-全部门店 */
    WM_POI_ID_ALL = 'wmPoiIdAll',
    /** im */
    IM = 'IM',
    /** push消息 */
    PUSH_MESSAGE = 'pushMessage',
}

/** 拼单一起送 */

enum CombineOrderNoticeContentStyle {
    // 普通文本
    NORMAL_TEXT = 1,
    // 特别突出字体
    BOLD_RED_TEXT = 2,
    // 小字提示
    SMALL_FONTSIZE_TEXT = 3,
}

enum CombineOrderNoticeContentType {
    // 文本
    TEXT = 1,
    // 图片
    IMAGE = 2,
}
interface ICombineOrderNotice {
    /** 是否命中拼单一起送 */
    isPhfPoiGray: boolean;
    /** 是否开启拼单一起送 */
    isCombineOrder: boolean;
    /** 商家是否有打开一起送开关历史记录 */
    hasOpenedSendTogetherSwitch: boolean;
    /** 弹框标题 */
    title: string;
    /** 弹框内容 */
    description: {
        title: string;
        content: string;
    }[];
    /** 新版本弹框内容 */
    newDescription: {
        title: string;
        content: Array<{
            content: string;
            style: CombineOrderNoticeContentStyle;
            type: CombineOrderNoticeContentType;
        }>;
    }[];
}

/** 闪购 */
interface ICheckSCIndex {
    /** 是否闪购 */
    scIndex: boolean;
    /** 闪购首页地址 */
    scIndexUrl: string;
}

interface IBetterAuth {
    auth: boolean;
}

export {
    IAllPoiList,
    IKangarooInfo,
    KangarooStatus,
    IBusinessStatus,
    BusinessStatus,
    BusinessSubStatus,
    IChangeBusinessStatus,
    IUnreadMessageCount,
    UnreadMessageType,
    IQueryMenu,
    IQueryMenuItem,
    IQuerySubMenuItem,
    IMenuInfoItem,
    IMenuInfo,
    IBusinessStatusHandlerItem,
    IgrayNewPageConfig,
    IgrayNewPageConfigAdvanced,
    IcustomerServiceInfo,
    MatchedMenuType,
    CompensateProtocalType,
    CustomizedShowArrType,
    CombineOrderNoticeContentStyle,
    CombineOrderNoticeContentType,
    ICombineOrderNotice,
    ICheckSCIndex,
    IBetterAuth,
};
